import React from "react";

const StockLineItemsTab = ({ stockDetailsList, formatCustomNumber }) => {
  // Calculate totals for all numeric columns
  const totals = stockDetailsList?.reduce(
    (acc, item) => {
      acc.physical += Number(item.physical_stock_quantity) || 0;
      acc.committed += Number(item.committed_order_quantity) || 0;
      acc.purchaseTransit += Number(item.purchase_transit_quantity) || 0;
      acc.warehouseTransit += Number(item.warehouse_transit_quantity) || 0;
      acc.salesShipped += Number(item.sales_quantity_shipped) || 0;
      acc.accounting += Number(item.accounting_quantity) || 0;
      return acc;
    },
    {
      physical: 0,
      committed: 0,
      purchaseTransit: 0,
      warehouseTransit: 0,
      salesShipped: 0,
      accounting: 0,
    }
  ) || {
    physical: 0,
    committed: 0,
    purchaseTransit: 0,
    warehouseTransit: 0,
    salesShipped: 0,
    accounting: 0,
  };

  return (
    <div>
      <div className="overflow-x-auto border border-gray-200 rounded-xl">
        <table className="w-full text-sm">
          <thead className="bg-gray-100 text-gray-700 uppercase text-xs">
            <tr>
              <th className="px-4 py-3 text-left">Warehouse</th>
              <th className="px-4 py-3 text-left">Physical Stock</th>
              <th className="px-4 py-3 text-left">Commited Order Stock</th>
              <th className="px-4 py-3 text-left">Purchased Transit Stock</th>
              <th className="px-4 py-3 text-left">Warehouse Transit Stock</th>
              <th className="px-4 py-3 text-left">Sales Shipped Stock</th>
              <th className="px-4 py-3 text-left">Accounting Stock</th>
            </tr>
          </thead>
          <tbody>
            {stockDetailsList?.length > 0 ? (
              <>
                {stockDetailsList.map((item, i) => (
                  <tr key={i} className="border-b hover:bg-gray-50">
                    <td className="px-4 py-3">{item.warehouse_name}</td>
                    <td className="px-4 py-3 text-gray-600">
                      {formatCustomNumber(item.physical_stock_quantity)}
                    </td>
                    <td className="px-4 py-3 text-gray-600">
                      {formatCustomNumber(item.committed_order_quantity)}
                    </td>
                    <td className="px-4 py-3 text-gray-600">
                      {formatCustomNumber(item.purchase_transit_quantity)}
                    </td>
                    <td className="px-4 py-3 text-gray-600">
                      {formatCustomNumber(item.warehouse_transit_quantity)}
                    </td>
                    <td className="px-4 py-3 text-gray-600">
                      {formatCustomNumber(item.sales_quantity_shipped)}
                    </td>
                    <td className="px-4 py-3 text-gray-600">
                      {formatCustomNumber(item.accounting_quantity)}
                    </td>
                  </tr>
                ))}

                {/* SUMMARY / TOTAL ROW AT THE BOTTOM */}
                <tr className="border-t-2 bg-gray-100 font-semibold">
                  <td className="px-4 py-3 text-gray-800">Total</td>
                  <td className="px-4 py-3 text-gray-800">
                    {formatCustomNumber(totals.physical)}
                  </td>
                  <td className="px-4 py-3 text-gray-800">
                    {formatCustomNumber(totals.committed)}
                  </td>
                  <td className="px-4 py-3 text-gray-800">
                    {formatCustomNumber(totals.purchaseTransit)}
                  </td>
                  <td className="px-4 py-3 text-gray-800">
                    {formatCustomNumber(totals.warehouseTransit)}
                  </td>
                  <td className="px-4 py-3 text-gray-800">
                    {formatCustomNumber(totals.salesShipped)}
                  </td>
                  <td className="px-4 py-3 text-gray-800">
                    {formatCustomNumber(totals.accounting)}
                  </td>
                </tr>
              </>
            ) : (
              <tr>
                <td colSpan={6} className="text-center py-8 text-gray-500">
                  No line items found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StockLineItemsTab;